module.exports = __webpack_public_path__ + "static/media/Exit.01cc8cc1.svg";